import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid ${({ theme }) => theme.designToken.neutral300};
  box-shadow: ${({ theme }) => theme.designToken.boxShadow1};
  width: 160px;
  background: ${({ theme }) => theme.designToken.baseWhite};
`;

export const ActionsMenu: FC = ({ children }) => <Container data-testid="ActionsMenu">{children}</Container>;
